module.exports = __webpack_public_path__ + "media/images/emblems/Udligenswil_LU-dedb0d5c1624033e06fb579572ef732f.png";